import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { getSanitizedState } from '../../../lib/redux/selectors';
import { setProgressBarData } from '../../../lib/redux/actions';
import { get } from '../../../lib/api';

const getProgressBar = ({ campaignUuid }) => {
  const params = {
    campaign_id: campaignUuid,
  };

  return get(`/api/progress_bar`, params);
};

const useGetProgressBarData = ({ campaignUuid }) => {
  const { userData, demo, progressBarData, organization } = useSelector(
    getSanitizedState,
  );
  const dispatch = useDispatch();
  const fetchProgressBarOldAirbo =
    !campaignUuid && !progressBarData.campaignUuid;
  const fetchProgressBarNewAirbo =
    progressBarData.campaignUuid !== campaignUuid;
  const fetchProgressBar = fetchProgressBarOldAirbo || fetchProgressBarNewAirbo;

  useEffect(() => {
    if (
      organization.name &&
      userData.id &&
      (!progressBarData.loaded || fetchProgressBar)
    ) {
      getProgressBar({ campaignUuid }).then(progressBar => {
        const pointsTowardsTicket =
          progressBar.points - progressBar.ticketThreshold;
        const raffleBarCompletion = ((pointsTowardsTicket % 20) / 20) * 100;
        const updateData = {
          startingPoints: progressBar.points,
          raffleBarCompletion,
          ticketThresholdBase: progressBar.ticketThreshold,
          points: progressBar.points,
          raffleTickets: progressBar.tickets,
          incompletedTiles: progressBar.incompletedTiles,
          completedTiles: 0,
          raffle: progressBar.raffle,
          hasRaffle: progressBar.hasRaffle,
          color: progressBar.color,
          campaignUuid,
          loaded: true,
        };

        dispatch(setProgressBarData(updateData));
      });
    }
  }, [
    dispatch,
    organization.name,
    userData,
    fetchProgressBarOldAirbo,
    fetchProgressBarNewAirbo,
    campaignUuid,
    fetchProgressBar,
    progressBarData.loaded,
  ]);

  const completedTilesPercentage =
    (progressBarData.completedTiles / progressBarData.incompletedTiles) * 100;

  return {
    demo,
    completedTilesPercentage,
    progressBarData,
    userData,
    organization,
  };
};

export default useGetProgressBarData;
